import React from "react";
import ReactApexChart from "react-apexcharts";

interface ApexChartProps {
  chartData?: any[];
  nestedData?: any[];
}

const MultiLineZoomChart: React.FC<ApexChartProps> = ({
  chartData = [],
  nestedData = [],
}) => {
  // Use nestedData only if chartData is empty or not provided
  const activeData = chartData.length > 0 ? chartData : nestedData;
  const useNested = chartData.length === 0 && nestedData.length > 0;

  const options = {
    chart: {
      height: 350,
      id: "line",
    },
    stroke: {
      width: 1.5,
      curve: "smooth" as "smooth",
    },
    xaxis: {
      categories: useNested
        ? nestedData.map((data: any) => data.Date)
        : chartData.map((data) => data.Date).reverse(),
    },
    tooltip: useNested
      ? {
          shared: false,
          custom: function ({
            series,
            seriesIndex,
            dataPointIndex,
            w,
          }: {
            series: number[][];
            seriesIndex: number;
            dataPointIndex: number;
            w: any;
          }) {
            const countryName = w.globals.seriesNames[seriesIndex];
            const details = nestedData[dataPointIndex][countryName];

            return `
            <div>
              <strong style="display:block;background:#f1f1f1;padding:6px">${countryName}</strong>
              <strong style="display:block;padding:12px 6px 0;font-weight:600">Total: ${
                details?.total || 0
              }</strong> 
              <div style="padding:6px">
              ${Object.entries(details || {})
                .map(([key, value]) =>
                  key !== "total" ? `${key}: ${value}` : ""
                )
                .filter(Boolean)
                .join("<br />")}
                
              </div>
            </div>
          `;
          },
        }
      : {},
  };

  const series = useNested
    ? Object.keys(nestedData[0] || {})
        .filter((key) => key !== "Date")
        .map((key) => ({
          name: key,
          data: nestedData.map((data: any) => data[key]?.total || 0),
        }))
    : Object.keys(chartData[0])
        .filter((key) => key !== "Date")
        .map((key) => ({
          name: key,
          data: chartData.map((data: any) => data[key]).reverse(),
        }));

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          width="98%"
          height={350}
        />
      </div>
    </div>
  );
};

export default MultiLineZoomChart;
